import BaseService from '@/ecm/common/BaseService.js';

class LinkedDocumentService {
    baseUrl = 'linked-document';

    getList = (mainDocumentId) => BaseService.get({ url: `${this.baseUrl}/${mainDocumentId}` });
    remove = (id) => BaseService.delete({ url: `${this.baseUrl}/${id}` });
    edit = (id, linkedDocument) => BaseService.put({ url: `${this.baseUrl}/${id}`, data: linkedDocument });
    save = (mainDocumentId, linkedDocuments) => BaseService.post({ url: `${this.baseUrl}/${mainDocumentId}`, data: linkedDocuments });
}

export default new LinkedDocumentService();
